/*
 * @Author: zhangcongcong zhangcongcong@move2newidea.com
 * @Date: 2023-08-11 17:57:47
 * @LastEditors: zhangcongcong zhangcongcong@move2newidea.com
 * @LastEditTime: 2024-02-21 11:12:42
 * @FilePath: /memo-web/src/components/memos/markDownPreview.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { useEffect, useState, useRef } from 'react'
import '../../static/markDown/github-markdown.min.css';
// import '../../static/markDown/prism-autoloader.min.js';
// import '../../static/markDown/prism-core.min.js';
import '../../static/markDown/prism-line-numbers.min.css';

// import '../../static/markDown/prism-line-numbers.min.js';
import '../../static/markDown/prism.min.css';
import useStore from '../../store/useStore'

import { Modal, } from 'antd'
import VditorPreview from "vditor";
// 
import ModelScreen from './modelScreen';

interface Props {
    visible?: any,
    content: any,
    onClose?: () => void;
    isNoModal?: any,
    id?: any
}
interface DataType {
}

const Preview = (props: Props) => {
    let preview: any
    const { store, dispatch } = useStore();
    const [iframeUrl, setIframeUrl] = useState<any>('');

    useEffect(() => {
        if (props.visible) {
            // preview=new VditorPreview("vditor1", {
            //     value:props.content,
            // })
            // VditorPreview.mermaidRender((document as any).querySelector('.vditor1'), props.content, '')
            // VditorPreview.preview((document as any).querySelector('.vditor1'), props.content)
            console.log('store.memoInfo?.data?.mimeType', store.memoInfo?.data?.mimeType, props.content)
            if (store.memoInfo?.data?.mimeType == 'text/webpage') {
                let _url = store.myEditMemo?.data?.tagMetas.find((i: any) => i.mimeType == "text/webpage")
                setIframeUrl(_url?.instance?.url)
            } else {
                setTimeout(() => {
                    VditorPreview.preview((document as any).querySelector('.vditor1'), props.content, { mode: 'light', cdn: "https://static.move2newidea.com/vditor/3.9.7" })
                }, 200);
            }
        } else {
            // preview&&preview.clearCache()
            // preview&&preview.destroy()
        }
    }, [props.visible])
    useEffect(() => {
        if (props.isNoModal) {
            console.log('props.content', props.content, props, props.isNoModal)
            // VditorPreview.mermaidRender((document as any).querySelector(`.preview_${props.id}`), props.content, '')
            // VditorPreview.preview((document as any).querySelector(`.preview_${props.id}`), props.content)
            VditorPreview.preview((document as any).querySelector(`.preview_${props.id}`), props.content, { mode: 'light', cdn: "https://static.move2newidea.com/vditor/3.9.7" })

        }
    }, [props.isNoModal])
    return (
        <>
            {props.isNoModal ? <>
                <div id={`preview_${props.id}`} className={`preview_${props.id}`} /></> :
                <Modal
                    centered
                    footer={null}
                    closable={true}
                    width={store.modelFullScreen ? '100%' : '800px'}
                    title={<ModelScreen showSelect={false} />}
                    onCancel={() => {
                        props.onClose && props.onClose()
                    }}
                    className="HScreen"
                    maskClosable={true}
                    open={props.visible}>
                    <div className='modalPreview'>

                        {store.memoInfo?.data?.mimeType !== "text/webpage" && <><div id="vditor1" className="vditor1" /></>}
                        {store.memoInfo?.data?.mimeType == "text/webpage" && <>
                            <iframe src={iframeUrl} className='iframe' style={{ height: `90vh` }}></iframe>
                        </>}
                        {/* {(store.memoInfo?.data?.mimeType == "text" || !store.memoInfo?.data?.mimeType) && <>{store.memoInfo?.data?.content}</>} */}
                    </div>
                    {/* <div className='markdown-body' style={{
                height: "50vh",
                maxHeight: '80vh',
                overflow: "scroll"
            }} dangerouslySetInnerHTML={{
                __html: `<div>${props.content && props.content.replace(/\n/g, '</br>')}<div>`
            }}>
            </div>
            <div id="vditor" className="vditor"  /> */}

                </Modal>}
        </>
    )
}

export default Preview